import DataTable from "datatables.net-react";
import { useEffect, useState } from "react";
import { Col, Row, } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { MarginmanagementServices } from "../../services/MarginManagementServices";
import * as BullCache from "../../util/BullCache";
import AdminDropdown from "../components/AdminDropdown";
import BrokerDropdown from "../components/BrokerDropdown";
import ClientDropdown from "../components/ClientDropdown";
import MasterDropdown from "../components/MasterDropdown";
import "../custom.css";

function Marginmanagement() {
  const [loading, setLoading] = useState(false);
  const [margin, setMargin] = useState([]);
  const [marginData, setMarginData] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);

  var user = BullCache.getFromCache("user");

  useEffect(() => {
    setLoading(true);
    MarginmanagementServices.margin({ adminId: user.adminId }).then((res) => {
      setLoading(false);
      if (res.code === 1) {
        if (res.data.marginList.length > 0) {
          setMargin(res.data.marginList);
        }
      }
    });
  }, [user.adminId]);

  const handleSubmit = () => {
    var request = {
      adminId: user.adminId,
    };

    if (selectedClient) {
      request.userId = selectedClient;
      request.adminId = user.adminId;
    } else if (selectedSubBrokerId) {
      request.adminId = selectedSubBrokerId.value;

    } else if (selectedBrokerId) {
      request.adminId = selectedBrokerId;
    } else if (selectedMaster) {
      request.adminId = selectedMaster.value;
    } else if (selectedAdmin) {
      request.adminId = selectedAdmin.value;
    }
    setLoading(true);
    MarginmanagementServices.margin(request).then((res) => {
      setLoading(false);
      if (res.code === 1 && Array.isArray(res.data?.marginList)) {
        if (res.data.marginList.length > 0) {
          setMargin(res.data.marginList);
        } else {
          setMarginData([]);
        }
      } else {
        setMarginData([]);
      }
    });
  };

  useEffect(() => {
    const formatNumber = (num) => {
      return Number(num).toFixed(2); // or you can use any custom logic here
    };
  
    setMarginData(
      margin.map((entry) => [
        `${entry.user.firstName} (${entry.user.userName})`,
        `${formatNumber(entry?.nseMargin?.usedAmount ?? 0)}/${formatNumber(entry?.nseMargin?.amount ?? 0)}`,
        `${formatNumber(entry?.nseMargin?.usedLot ?? 0)}/${formatNumber(entry?.nseMargin?.lot ?? 0)}`,
        `${formatNumber(entry?.mcxMargin?.usedAmount ?? 0)}/${formatNumber(entry?.mcxMargin?.amount ?? 0)}`,
        `${formatNumber(entry?.mcxMargin?.usedLot ?? 0)}/${formatNumber(entry?.mcxMargin?.lot ?? 0)}`,
        `${formatNumber(entry?.globalMargin?.usedAmount ?? 0)}/${formatNumber(entry?.globalMargin?.amount ?? 0)}`,
        `${formatNumber(entry?.globalMargin?.usedLot ?? 0)}/${formatNumber(entry?.globalMargin?.lot ?? 0)}`
      ])
    );
  }, [margin]);
  
  const handleSelectedClientChange = (selected) => {
    setSelectedClient(selected?.userId);
  };

  return (
    <div className="container-fluid">
      <Card className="mt-2">
        <Card.Body>
          <Row>
            {user.adminType === 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col xl={2} xs={6}>
                  <b className="fss-05">ADMIN</b>
                  <AdminDropdown
                    adminId={user.adminId}
                    setSelectedOption={setSelectedAdmin} />
                </Col>
              </> : ""}

            {user.adminType === 'SUPER_ADMIN' || user.adminType === 'ADMIN' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col xs={6} xl={2}>
                  <b className="fss-05">MASTER</b>
                  <MasterDropdown
                    adminId={user.adminId}
                    selectedAdmin={selectedAdmin}
                    setSelectedOption={setSelectedMaster}
                    setSelectedMaster={setSelectedMaster}
                    setSelectedBrokerId={setSelectedBrokerId}
                  />
                </Col>
              </> : ""}

            {user.adminType === 'SUPER_ADMIN' || user.adminType === 'ADMIN' || user.adminType === 'MASTER' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col xs={6} xl={2}>
                  <b className="fss-05">BROKER</b>
                  <BrokerDropdown
                    selectedAdmin={selectedAdmin}
                    selectedMaster={selectedMaster}
                    setSelectedOption={setSelectedBrokerId}
                    setSelectedBrokerId={setSelectedBrokerId}
                    setSelectedSubBrokerId={setSelectedSubBrokerId}
                  />
                </Col>
              </> : ""}

            <Col xs={6} xl={2}>
              <b className="fss-05">CLIENT</b>
              <ClientDropdown
                selectedAdmin={selectedAdmin}
                selectedMaster={selectedMaster}
                selectedBrokerId={selectedBrokerId}
                setSelectedOption={handleSelectedClientChange}
              />

            </Col>

            <Col>
              <Button
                variant="success"
                className="mt-4 custom-btn"
                size="sm"
                onClick={handleSubmit}
              >
                Search
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mt-1">
        <Card.Body>
          <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
                <div className="d-flex align-items-center justify-content-center h-90">
                  <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <DataTable
                className="custom-table bg-secondary-row"
                data={marginData}
              >
                <thead>
                  <tr className="text-center ">
                    <th className=" fss-09">
                      NAME
                    </th>
                    <th className=" fss-09" colSpan={2}>
                      NSEFUT
                    </th>
                    <th className=" fss-09" colSpan={2}>
                      MCXFUT
                    </th>
                    <th className=" fss-09" colSpan={2}>
                      GLOBAL
                    </th>
                  </tr>

                  <tr className="">
                    <th className=""></th>
                    <th className=" fss-08 left-align">
                      AMOUNT (Used/Total)
                    </th>
                    <th className=" fss-08 left-align">
                      LOT (Used/Total)
                    </th>
                    <th className=" fss-07 left-align">
                      AMOUNT (Used/Total)
                    </th>
                    <th className=" fss-07 left-align">
                      LOT (Used/Total)
                    </th>
                    <th className=" fss-07 left-align">
                      AMOUNT (Used/Total)
                    </th>
                    <th className=" fss-07 left-align">
                      LOT (Used/Total)
                    </th>
                  </tr>
                </thead>

                <tbody></tbody>
              </DataTable>
            )}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
export default Marginmanagement;
